import { gql } from '@apollo/client';
import React from 'react';

import { toAbsoluteMoment } from 'src/components/affectedOperations/affectedOperationsHelpers';
import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const TimeRangeSentenceSchemaDiffValidationConfigFragment = gql`
  fragment TimeRangeSentenceSchemaDiffValidationConfigFragment on SchemaDiffValidationConfig {
    from
    to
    queryCountThreshold
    includedVariants
  }
`;

export function TimeRangeSentence({
  graphTitle,
  createdAt,
  config,
}: {
  graphTitle: string;
  createdAt: string | number;
  config: GraphQLTypes.TimeRangeSentenceSchemaDiffValidationConfigFragment | null;
}) {
  return (
    <>
      This check for <em>{graphTitle}</em> ran against operations from{' '}
      {config?.from ? (
        <LocalTimestamp
          value={toAbsoluteMoment(config.from, createdAt).toDate()}
        />
      ) : (
        '--'
      )}
      {' - '}
      {config?.to ? (
        <LocalTimestamp
          value={toAbsoluteMoment(config.to, createdAt).toDate()}
        />
      ) : (
        '--'
      )}{' '}
      that were reported at least {config?.queryCountThreshold} times.
    </>
  );
}
